import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const PersonalSumWorkReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default PersonalSumWorkReport
